import { TabsProps } from 'antd';

export const tabs: TabsProps['items'] = [
    { key: 'manage', label: 'Управление' },
    { key: 'monitoring', label: 'Мониторинг' },
];
